import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isTouchDevice = () => window.matchMedia('(hover: none)').matches;

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const showTooltip = () => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    setTooltipVisible(true);
  };

  const hideTooltip = () => {
    hideTimer.current = setTimeout(() => setTooltipVisible(false), 150);
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault();
    showTooltip();
    hideTimer.current = setTimeout(() => {
      setTooltipVisible(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 1200);
  };

  const scrollToTop = () => {
    if (!isTouchDevice()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <div
          className="fixed z-50 flex items-center"
          style={{ bottom: '172px', right: '24px' }}
          onMouseEnter={() => !isTouchDevice() && showTooltip()}
          onMouseLeave={() => !isTouchDevice() && hideTooltip()}
        >
          <AnimatePresence>
            {tooltipVisible && (
              <motion.span
                key="tooltip-scroll"
                initial={{ opacity: 0, x: 10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                transition={{ duration: 0.2 }}
                className="hidden md:block mr-3 whitespace-nowrap bg-[#0A1628] text-white text-xs font-medium px-3 py-1.5 rounded-lg shadow-lg pointer-events-none select-none relative"
              >
                Voltar ao topo
                <span className="absolute right-[-5px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-t-transparent border-b-transparent border-l-[#0A1628]" />
              </motion.span>
            )}
          </AnimatePresence>

          <motion.button
            key="scroll-to-top"
            initial={{ opacity: 0, scale: 0.5, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.5, y: 20 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            onClick={scrollToTop}
            onTouchStart={handleTouchStart}
            aria-label="Voltar ao topo"
            className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center bg-[#0A1628] text-[#D4AF37] rounded-full shadow-xl hover:bg-[#D4AF37] hover:text-[#0A1628] transition-all duration-300 cursor-pointer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <i className="ri-arrow-up-line text-base sm:text-xl"></i>
          </motion.button>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopButton;
